<template>
  <div>
    <div class="input" @click="initShowType">
      {{inputTime}}
    </div>
    <div v-if="isShow" class="picker-mask">

    </div>

    <div :class="{active:isShow}" class="picker-content">
      <div class="picker-header">
        <p @click="isShow=false">返回</p>
        <p @click="sureDate">确定</p>
      </div>
      <div class="picker-nav">
        <div v-if="showType.year">年</div>
        <div v-if="showType.month">月</div>
        <div v-if="showType.day">日</div>
        <div v-if="showType.hour">时</div>
        <div v-if="showType.minute">分</div>
      </div>
      <div class="picker-body">
        <div v-if="showType.year" class="picker year" @touchend="touchend('year',$event)" @touchstart.stop.prevent="touchStart('year',$event)" @touchmove="touchMove('year',$event)">
          <div class="picker-selected">

          </div>
          <div :style="touchArgv.year" class="picker-list">
            <div v-for="m in year" v-bind:key="m">{{m}}</div>
          </div>
        </div>
        <div v-if="showType.month" class="picker month" @touchend="touchend('month',$event)" @touchstart.stop.prevent="touchStart('month',$event)" @touchmove="touchMove('month',$event)">
          <div class="picker-selected">

          </div>
          <div :style="touchArgv.month" class="picker-list">
            <div v-for="m in month" v-bind:key="m">{{m}}</div>
          </div>
        </div>
        <div v-if="showType.day" class="picker day" @touchend="touchend('day',$event)" @touchstart.stop.prevent="touchStart('day',$event)" @touchmove="touchMove('day',$event)">
          <div class="picker-selected">

          </div>
          <div :style="touchArgv.day" class="picker-list">
            <div v-for="m in day" v-bind:key="m">{{m}}</div>
          </div>
        </div>
        <div v-if="showType.hour" class="picker hour" @touchend="touchend('hour',$event)" @touchstart.stop.prevent="touchStart('hour',$event)" @touchmove="touchMove('hour',$event)">
          <div class="picker-selected">

          </div>
          <div :style="touchArgv.hour" class="picker-list">
            <div v-for="m in hour" v-bind:key="m">{{m}}</div>
          </div>
        </div>
        <div v-if="showType.minute" class="picker minuer" @touchend="touchend('minute',$event)" @touchstart.stop.prevent="touchStart('minute',$event)" @touchmove="touchMove('minute',$event)">
          <div class="picker-selected">

          </div>
          <div :style="touchArgv.minute" class="picker-list">
            <div v-for="m in minute" v-bind:key="m">{{m}}</div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
//TODO 新增多入口
const moment = require('moment')
export default {
  props: ['time', 'type'],
  data() {
    return {
      //显示开关
      showType: {
        year: true,
        month: true,
        day: true,
        hour: true,
        minute: true
      },
      inputTime: moment().format("YYYY-MM-DD"),
      //自适应预留 单元高度
      cellHeight: 40,
      //面板开关
      isShow: false,
      //日期库
      year: [2014, 2015, 2016, 2017, 2018, 2019],
      month: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      day: [],
      hour: [],
      minute: [],
      touchArgv: {
        month: { top: '', num: 0 },
        year: { top: '', num: 0 },
        day: { top: '', num: 0 },
        hour: { top: '', num: 0 },
        minute: { top: '', num: 0 }
      },
      //当前选中的picker
      selected: {
        type: '',
        start: '',
        end: '',
        month: '',
        year: '',
        day: '',
        hour: '',
        minute: ''
      }
    }
  },
  created() {
    this.reloadDayList()
    this.initDataArr()

  },
  mounted() {
    this.initTime()
  },
  computed: {
    deltaY() {
      return this.selected.start - this.selected.end
    },

  },
  methods: {
    //读取配置
    initShowType() {
      this.isShow = true
      if (this.type === 'year') {
        for (let one in this.showType) {
          if (one !== 'year') {
            this.showType[one] = false
          }
        }
      } else if (this.type === 'month') {
        for (let one in this.showType) {
          if (one !== 'year' && one !== 'month') {
            this.showType[one] = false
          }
        }
      } else if (this.type === 'day') {
        for (let one in this.showType) {
          if (one === 'hour' || one === 'minute') {
            this.showType[one] = false
          }
        }
      } else {
        for (let one in this.showType) {

          this.showType[one] = true

        }
      }
    },
    initDataArr() {
      // 填充小时
      for (let i = 0; i < 24; i++) {
        if (i < 10) {
          this.hour[i] = '0' + i
        } else {
          this.hour[i] = i
        }
      }
      for (let i = 0; i < 60; i++) {
        if (i < 10) {
          this.minute[i] = '0' + i
        } else {
          this.minute[i] = i
        }
      }
    },
    touchStart(type, e) {
      this.selected.start = e.targetTouches[0].pageY
    },
    touchMove(type, e) {
      //当屏幕有多个touch或者页面被缩放过，就不执行move操作
      if (event.targetTouches.length > 1 || event.scale && event.scale !== 1) return

      this.selected.end = e.targetTouches[0].pageY
      // this.touchArgv[`${type}`].num = (this.touchArgv[`${type}`].num - this.deltaY)
      this.touchArgv[`${type}`].top = (this.touchArgv[`${type}`].num - this.deltaY) + 'px'

      //  this.moveSelected(type)
    },
    touchend(type, e) {
      let num = this.touchArgv[`${type}`].num
      num = num - this.deltaY
      this.moveSelected(type, num)
    },
    moveSelected(type, num) {
      // 滑动补全
      let yu = Math.abs(num % this.cellHeight)
      if (yu > this.cellHeight / 2) {
        num = num > 0 ? num - yu + this.cellHeight : num + yu - this.cellHeight
      } else {
        num = num > 0 ? num - yu : num + yu
      }
      // 范围限制
      let maxTop, minTop, length,
        cellHeight = this.cellHeight
      length = this[`${type}`].length
      minTop = -(length - 3) * cellHeight
      maxTop = 2 * cellHeight
      if (num > maxTop) {
        num = maxTop
      } else if (num < minTop) {
        num = minTop
      }
      // 赋值
      this.touchArgv[`${type}`].top = (num) + 'px'
      this.touchArgv[`${type}`].num = num
      // 计算选中
      let n = (num - 2 * cellHeight) / 40
      this.selected[`${type}`] = this[`${type}`][Math.abs(n)]
      if (type === 'month') {
        this.reloadDayList(this.selected[`${type}`])
      }

    },
    //重新填充下级数组
    reloadDayList(month) {
      if (!month) { month = 1 }
      let len = moment(month, 'M').daysInMonth()
      this.day = []
      for (let i = 0; i < len; i++) {
        if (i < 9) {
          this.day[i] = '0' + (i + 1)
        } else {
          this.day[i] = i + 1
        }

      }
    },
    // TODO 时间格式的处理
    dateFormat() {
      let select = this.selected,
        showType = this.showType,
        time
      if (!select.year) {
        time = moment().format('YYYY-MM-DD HH:mm')
      } else {
        time = moment(select.year + select.month + select.day + select.hour + select.minute, 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm')
      }
      if (this.type === 'year') {
        time = moment(time).format('YYYY')
      } else if (this.type === 'day') {
        time = moment(time).format('YYYY-MM-DD')
      } else if(this.type==='month') {
         time = moment(time).format('YYYY-MM')
      }
      return time
    },
    sureDate() {
      let select = this.selected
      let time
      time = this.dateFormat()
      this.$emit('input', time)
      this.inputTime = time
      this.isShow = false
    },
    // 初始化 TODO 更好的时间载入方法
    initTime() {
      let height = this.cellHeight,
        now = moment().format('YYYYMMDDHHmm')
      this.selected.year = now.slice(0, 4)
      this.selected.month = now.slice(4, 6)
      this.selected.day = now.slice(6, 8)
      this.selected.hour = now.slice(8,10)
      this.selected.minute = now.slice(10,12)
      this.touchArgv.year.top = ((2016 - now.slice(0, 4)) * height) + 'px'
      this.touchArgv.month.top = ((3 - now.slice(4, 6)) * height) + 'px'
      this.touchArgv.day.top = ((3 - now.slice(6, 8)) * height) + 'px'
      this.touchArgv.hour.top = ((2 - now.slice(8, 10)) * height) + 'px'
      this.touchArgv.minute.top = ((2 - now.slice(10, 12)) * height) + 'px'
    }
  }

}
</script>

<style scoped>
.input {
  background-image: none;
  box-sizing: border-box;
  color: #fff;
    width: 100%;
  line-height: 1;
  outline: 0;
  padding: 3px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
    white-space: nowrap;
  font-size: 14px;
    text-decoration: underline;

}

.picker-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9
}

.picker-content {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  bottom: -150px;
  left: 0;
  z-index: 999;
  width: 100%;
  background: white;
  transition: all .3s;
}

.picker-header {
  display: flex;
  justify-content: space-between;
  /* border: 1px solid #ccc; */
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  color: #0576fe;
}

.picker-header>p {
  margin: 0 15px
}

.picker-nav {
  width: 100%;
  display: flex;
  height: 30px;
  background: #0576fe;
  color: white;
}

.picker-nav>div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.picker-body {
  width: 100%;
  display: flex;
  height: 200px;
  overflow: hidden
}

.picker-body>.picker {
  flex: 1;
  height: 100%;
  /* border: 1px solid #ccc; */
  position: relative;
}

.picker>.picker-list {
  position: absolute;
  width: 100%;
  top: 80px;
  font-size: 19px;
  color: black
}

.picker>.picker-list>div {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center
}

.picker-selected {
  border: 1px solid #0576fe;
  position: absolute;
  border-left: none;
  border-right: none;
  top: 80px;
  left: 0;
  height: 40px;
  width: 100%
}

.active {
  visibility: visible;
  opacity: 1;
  bottom: 0
}





/*进出的渐变效果  */

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active 在低于版本 2.1.8 中 */

{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// datePick.vue?5c4f1710